import { InputField, SelectInput } from "../../../blueplanitUtils/InputField";
import { Link } from "react-router-dom";
import { getOptionsByPath } from '../../../utilsdata.js';
import { ADD_CLIENT,ADD_CLIENT_DEPARTMENT } from "../../../Dropdownmanager.jsx";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";
const PointOfContacts = ({ agencyData, setAgencyData, errors, setErrors }) => {


    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const trimmedValue = (name === "Email" || name === "Phone") ? value.trim() : value;

        const updatedContacts = agencyData.PointofContact.map((contact, i) =>
            i === index ? { ...contact, [name]: trimmedValue } : contact
        );

        // Clone errors deeply to prevent unintended mutations
        const updatedErrors = { ...errors };
        updatedErrors.pointOfContact = [...(errors.pointOfContact || [])];

        if (!updatedErrors.pointOfContact[index]) {
            updatedErrors.pointOfContact[index] = {};
        }

        // Email validation
        if (name === "Email") {
            if (!validateEmail(trimmedValue)) {
                updatedErrors.pointOfContact[index].Email = "Invalid email format";
            } else {
                delete updatedErrors.pointOfContact[index].Email;
            }
        }

        setAgencyData(prev => ({ ...prev, PointofContact: updatedContacts }));
        setErrors(updatedErrors);
    };

    const handleAddMore = () => {
        const newContact = { PersonName: "", Email: "", Phone: "", Designation: "", Department: "" };

        const currentContacts = Array.isArray(agencyData?.PointofContact)
            ? agencyData.PointofContact
            : [];

        setAgencyData({
            ...agencyData,
            PointofContact: [...currentContacts, newContact]
        });

    };

    const deleteContact = (index) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedContacts = [...(agencyData?.PointofContact || [])];
                updatedContacts.splice(index, 1);
                setAgencyData({
                    ...agencyData,
                    PointofContact: updatedContacts
                });

            }
        })
    };

    return (
        <div className="card tab-box" style={{ marginTop: "6px" }}>
            <h3 className="mx-auto" style={{ fontSize: "20px",marginTop:"6px"}}>Point of Contact</h3>
            <div className="form-scroll">
                {agencyData?.PointofContact?.map((contact, index) => (
                    <div className="card mb-0" key={index}>
                        <div className="card-body">
                            <h4 className="card-title">
                                Contact {index + 1}
                                <Link to="#" className="delete-icon float-end" onClick={() => deleteContact(index)}>
                                    <i className="fa-regular fa-trash-can" />
                                </Link>
                            </h4>
                            <div className="row justify-content-between">
                                <div className="col-md-2 mb-3">
                                    <InputField
                                        formcontrol="form-control"
                                        label="Person Name"
                                        type="text"
                                        name="PersonName"
                                        value={contact?.PersonName}
                                        onChange={(e) => handleInputChange(index, e)}
                                    />
                                </div>
                                <div className="col-md-3 mb-2" >
                                    <InputField
                                        formcontrol="form-control"
                                        label="Email"
                                        type="email"
                                        name="Email"
                                        value={contact?.Email}
                                        onChange={(e) =>
                                            handleInputChange(index, {
                                                target: {
                                                    name: "Email",
                                                    value: e.target.value.trim()
                                                }
                                            })
                                        }
                                    />
                                </div>
                                <div className="col-md-2 mb-2" >
                                    <InputField
                                        formcontrol="form-control"
                                        label="Phone"
                                        type="number"
                                        name="Phone"
                                        value={contact?.Phone?.trim()}
                                        onChange={(e) => handleInputChange(index, e)}
                                    />
                                </div>
                                <div className="col-md-2 mb-2">
                                    <SelectInput
                                        label="Department"
                                        name="Department"
                                        value={contact?.Department}
                                        onChange={(e) =>
                                            handleInputChange(index, {
                                                target: { name: "Department", value: e }
                                            })
                                        }
                                        formControl={true}
                                        options={getOptionsByPath(NestedDatabucket, [ADD_CLIENT, ADD_CLIENT_DEPARTMENT])}
                                        style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                    />
                                </div>
                                <div className="col-md-2 mb-2" >
                                    <InputField
                                        label="Designation"
                                        name="Designation"
                                        value={contact?.Designation}
                                        onChange={(e) => handleInputChange(index, e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                <div className="text-end mb-3">
                    <button className="btn btn-sm btn-primary me-3" onClick={handleAddMore}>
                        <i className="fa fa-plus pe-2" />
                        Add Contact
                    </button>
                </div>
            </div>
            <style>



            </style>
        </div>
    );
};

export default PointOfContacts;
